/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  SvgIcon,
  Button
} from '../'

import {
  getAvatarInitialsColour
} from '../../utils'

export class ActivityTimelineEntry extends React.Component {
  static propTypes = {
    date: PropTypes.string,
    identity: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }),
    action: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.array
    ]),
    identifier: PropTypes.string.isRequired,  // SvgIcon symbol
    identifierText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    details: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    toolbar: PropTypes.element,  // ActionsToolbar
    footer: PropTypes.element,
    fromAddr: PropTypes.string,
    defaultContentSize: PropTypes.number
  }

  static defaultProps = {
    defaultContentSize: 175
  }

  constructor(props) {
    super(props)

    this.state = {
      showShowMoreButton: false,
      showMore: false
    }
  }

  componentDidMount() {
    let bodyContentSize = this.details.scrollHeight
    if (bodyContentSize > this.props.defaultContentSize) {
      this.setState({ showShowMoreButton: true })
    }
  }

  render() {
    let identity = null
    let initials = null

    if (this.props.identity !== null) {
      identity = `${this.props.identity.firstName} ${this.props.identity.lastName}`
      initials = `${this.props.identity.firstName[0]}${this.props.identity.lastName[0]}`
    } else {
      identity = "Unknown"
      initials = "?"
    }

    let avatarInitialsColour = getAvatarInitialsColour(initials)

    return (
      <div className="slds-grid slds-m-bottom_medium">
        <div className="case-note-timestamp slds-m-right_large slds-p-top_large">
          {moment(this.props.date).format("HH:mm")}
        </div>
        <div className={`slds-size_1-of-12 slds-text-align_center case-timeline-event-identifier_${this.props.identifier} slds-p-left_xx-small slds-p-right_xx-small`}>
          <SvgIcon
            variant="picsaos"
            symbol={this.props.identifier}
            colour={this.props.identifier}
            className="slds-m-top_large"
          />
          {this.props.identifierText &&
            <div className='slds-text-body_small slds-m-top_xx-small slds-text-color_weak' style={{ lineHeight: 1.2 }}>
              {this.props.identifierText}
            </div>
          }
        </div>
        <div className="case-timeline-entry slds-grid slds-size_5-of-6 slds-wrap slds-p-around_large u-bg-color-white">
          <div className="slds-col">
            <div className="case-note-descriptor slds-size_1-of-1 slds-m-bottom_small">
              <div className="slds-grid">  {/* TODO: add mapping to suit entry type */}
                <div className="slds-avatar slds-avatar_small slds-avatar_circle slds-m-right_medium">
                  <abbr
                    className={`slds-avatar__initials slds-icon-standard-user ${avatarInitialsColour ? `avatar-color_${avatarInitialsColour}` : ''}`}
                    title={identity}>
                    {initials}
                  </abbr>
                </div>
                <div className="slds-m-right_medium">
                  <b>{identity}</b>
                  &nbsp;
                </div>
                {this.props.fromAddr &&
                  <span>
                    {this.props.fromAddr}
                    &nbsp;
                  </span>
                }
                {this.props.action &&
                  <div>
                    {this.props.action}
                  </div>
                }
              </div>
            </div>
            <div className="case-note slds-size_11-of-12 slds-m-bottom_large">
              <div
                ref={(el) => this.details = el}
                style={{ maxHeight: this.state.showMore ? "fit-content" : this.props.defaultContentSize, overflow: 'hidden' }}>
                {this.props.details}
              </div>
              {this.state.showShowMoreButton
                ? <Button
                    type="reset"
                    onClick={() => this.setState({ showMore: true, showShowMoreButton: false })}>
                    <b>Show more</b>
                  </Button>
                : this.state.showMore &&
                  <Button
                    type="reset"
                    onClick={() => this.setState({ showMore: false, showShowMoreButton: true })}>
                    Show less
                  </Button>
              }
            </div>
            {this.props.toolbar}
            {this.props.footer}
          </div>
        </div>
      </div>

      // TODO: use placeholder below when adding mood
      // <div className="mood-indicator slds-text-align_right slds-col slds-size_1-of-12">
      //   <SvgIcon
      //     className="slds-m-right_x-small"
      //     variant="picsaos"
      //     symbol="face_happy"
      //     size="small"
      //     colour="success"
      //   />
      // </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/activity-timeline-entry/index.js